import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import "./Garantias.css";

function Garantias() {
  const coberturas = [
    {
      id: 1,
      icono: "bi-patch-check",
      titulo: "Posibles defectos de fabricación",
      descripcion:
        "Las solicitudes relacionadas con una posible falla de fabricación serán revisadas antes de determinar si corresponde la aplicación de garantía.",
    },
    {
      id: 2,
      icono: "bi-box-seam",
      titulo: "Producto en condiciones adecuadas",
      descripcion:
        "El estado físico del producto, su manipulación y las condiciones en que fue instalado pueden formar parte de la revisión.",
    },
    {
      id: 3,
      icono: "bi-receipt",
      titulo: "Comprobante de compra",
      descripcion:
        "Para facilitar la revisión, es recomendable presentar el comprobante o información que permita identificar la compra realizada.",
    },
  ];

  const exclusiones = [
    "Instalación incorrecta o realizada sin considerar las especificaciones del producto.",
    "Conexiones eléctricas inadecuadas, voltaje incorrecto o problemas en la alimentación eléctrica.",
    "Golpes, caídas, humedad, quemaduras o daños ocasionados después de la entrega.",
    "Manipulación, modificación, apertura o intervención del producto por terceros.",
    "Uso diferente al recomendado o utilización en condiciones no apropiadas.",
    "Daños producidos durante una instalación realizada por técnicos externos.",
  ];

  const pasos = [
    {
      id: 1,
      titulo: "Comunícate con nosotros",
      descripcion:
        "Indícanos qué producto presenta el inconveniente y proporciona la información de tu compra.",
    },
    {
      id: 2,
      titulo: "Describe el problema",
      descripcion:
        "Explícanos qué ocurrió y, cuando sea posible, comparte fotografías o información útil para la revisión.",
    },
    {
      id: 3,
      titulo: "Revisión del caso",
      descripcion:
        "Nuestro equipo evaluará la situación para determinar si el inconveniente corresponde al producto o a factores externos.",
    },
    {
      id: 4,
      titulo: "Respuesta",
      descripcion:
        "Después de la revisión te informaremos si corresponde garantía, cambio, devolución u otra solución aplicable.",
    },
  ];

  return (
    <div className="garantias-page">
      <Navbar />

      <main>
        {/* =====================================================
            HERO
        ===================================================== */}
        <section className="garantias-hero">
          <div className="garantias-container">
            <div className="garantias-hero-card">
              <div>
                <span className="garantias-kicker">
                  INFORMACIÓN PARA NUESTROS CLIENTES
                </span>

                <h1>Garantías y devoluciones</h1>

                <p>
                  Cada solicitud se revisa de forma individual. La garantía no se
                  aplica automáticamente, ya que es necesario determinar si el
                  inconveniente corresponde al producto o a factores relacionados
                  con instalación, manipulación o uso.
                </p>
              </div>

              <div className="garantias-hero-icon">
                <i className="bi bi-shield-check"></i>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            POLÍTICA
        ===================================================== */}
        <section className="garantias-section garantias-policy-section">
          <div className="garantias-container">
            <div className="garantias-section-header">
              <div>
                <span className="garantias-section-kicker">
                  NUESTRA POLÍTICA
                </span>

                <h2>¿Cómo manejamos una solicitud de garantía?</h2>

                <p>
                  Si un producto presenta un inconveniente, nuestro equipo revisa
                  el caso antes de determinar si corresponde una garantía.
                </p>
              </div>

              <div className="garantias-header-line"></div>
            </div>

            <div className="garantias-policy-card">
              <div className="garantias-policy-icon">
                <i className="bi bi-info-circle"></i>
              </div>

              <div>
                <h3>Evaluación previa</h3>

                <p>
                  En G&J Frío Industrial y Doméstico buscamos comercializar
                  productos y repuestos en condiciones adecuadas. Cuando un cliente
                  reporta una posible falla, la solicitud debe ser revisada para
                  determinar la causa del problema y la solución aplicable.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            COBERTURA
        ===================================================== */}
        <section className="garantias-section garantias-coverage-section">
          <div className="garantias-container">
            <div className="garantias-section-header">
              <div>
                <span className="garantias-section-kicker">
                  REVISIÓN DE GARANTÍA
                </span>

                <h2>Situaciones que pueden ser revisadas</h2>

                <p>
                  Estos aspectos pueden considerarse durante la evaluación de una
                  solicitud.
                </p>
              </div>

              <div className="garantias-header-line"></div>
            </div>

            <div className="garantias-coverage-grid">
              {coberturas.map((item) => (
                <article className="garantias-coverage-card" key={item.id}>
                  <span>
                    <i className={`bi ${item.icono}`}></i>
                  </span>

                  <h3>{item.titulo}</h3>

                  <p>{item.descripcion}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* =====================================================
            NO CUBIERTO
        ===================================================== */}
        <section className="garantias-section garantias-exclusions-section">
          <div className="garantias-container">
            <div className="garantias-exclusions-layout">
              <div className="garantias-exclusions-card">
                <div className="garantias-exclusions-header">
                  <span>
                    <i className="bi bi-exclamation-triangle"></i>
                  </span>

                  <div>
                    <small>IMPORTANTE</small>
                    <h2>Situaciones que pueden afectar la garantía</h2>
                  </div>
                </div>

                <div className="garantias-exclusions-list">
                  {exclusiones.map((item, index) => (
                    <div className="garantias-exclusion-item" key={index}>
                      <span>
                        <i className="bi bi-x-lg"></i>
                      </span>

                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <aside className="garantias-technician-card">
                <span className="garantias-technician-icon">
                  <i className="bi bi-tools"></i>
                </span>

                <span className="garantias-technician-kicker">
                  INSTALACIÓN POR TERCEROS
                </span>

                <h3>Productos instalados por técnicos externos</h3>

                <p>
                  G&J Frío comercializa repuestos y productos, pero una instalación
                  incorrecta realizada por terceros puede provocar daños que no
                  correspondan a una falla del producto.
                </p>
              </aside>
            </div>
          </div>
        </section>

        {/* =====================================================
            PROCESO
        ===================================================== */}
        <section className="garantias-section garantias-process-section">
          <div className="garantias-container">
            <div className="garantias-section-header">
              <div>
                <span className="garantias-section-kicker">
                  SOLICITAR REVISIÓN
                </span>

                <h2>¿Cómo solicitar una revisión?</h2>

                <p>
                  Sigue estos pasos para que nuestro equipo pueda revisar tu caso.
                </p>
              </div>

              <div className="garantias-header-line"></div>
            </div>

            <div className="garantias-process-grid">
              {pasos.map((paso, index) => (
                <article className="garantias-process-card" key={paso.id}>
                  <span className="garantias-process-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <h3>{paso.titulo}</h3>

                  <p>{paso.descripcion}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* =====================================================
            DEVOLUCIONES
        ===================================================== */}
        <section className="garantias-section garantias-returns-section">
          <div className="garantias-container">
            <div className="garantias-return-card">
              <span className="garantias-return-icon">
                <i className="bi bi-arrow-left-right"></i>
              </span>

              <div className="garantias-return-content">
                <span className="garantias-section-kicker">
                  CAMBIOS Y DEVOLUCIONES
                </span>

                <h2>Solicitudes de cambio o devolución</h2>

                <p>
                  Las solicitudes de cambio o devolución se revisan según el estado
                  del producto, motivo de la solicitud y condiciones de la compra.
                  Nuestro equipo evaluará cada caso antes de confirmar si procede.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            CTA
        ===================================================== */}
        <section className="garantias-final-section">
          <div className="garantias-container">
            <div className="garantias-final-card">
              <div>
                <span>¿TIENES UN INCONVENIENTE?</span>

                <h2>Comunícate con nuestro equipo</h2>

                <p>
                  Envíanos la información de tu compra y una descripción del
                  problema para revisar tu caso.
                </p>
              </div>

              <a
                href="https://wa.link/8proeq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-whatsapp"></i>
                Solicitar revisión
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default Garantias;
